import * as z from 'zod';

export const CreateMemberAboutRequest = z.object({
  memberAbout: z
    .object({
      _id: z
        .string()
        .describe('ID of the "About" section content.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
        )
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      content: z
        .any()
        .describe(
          '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
        ),
    })
    .describe('The "About" section content to create.'),
});
export const CreateMemberAboutResponse = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe(
      'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
    )
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  content: z
    .any()
    .describe(
      '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
    )
    .optional(),
});
export const UpdateMemberAboutRequest = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  memberAbout: z
    .object({
      _id: z
        .string()
        .describe('ID of the "About" section content.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
        ),
      memberId: z
        .string()
        .describe('Member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      content: z
        .any()
        .describe(
          '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
        ),
    })
    .describe('The "About" section content to update.'),
});
export const UpdateMemberAboutResponse = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe(
      'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
    )
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  content: z
    .any()
    .describe(
      '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
    )
    .optional(),
});
export const DeleteMemberAboutRequest = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteMemberAboutResponse = z.object({});
export const GetMemberAboutRequest = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content to retrieve.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetMemberAboutResponse = z.object({
  _id: z
    .string()
    .describe('ID of the "About" section content.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^\d+$/, 'Must be a valid UInt64 string')
    .describe(
      'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
    )
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  content: z
    .any()
    .describe(
      '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
    )
    .optional(),
});
export const GetMyMemberAboutRequest = z.object({});
export const GetMyMemberAboutResponse = z.object({
  memberAbout: z
    .object({
      _id: z
        .string()
        .describe('ID of the "About" section content.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
        )
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      content: z
        .any()
        .describe(
          '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
        )
        .optional(),
    })
    .describe('The "About" section content of the current member.')
    .optional(),
});
export const QueryMemberAboutsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          memberId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z.array(z.object({})).optional(),
    })
    .catchall(z.any())
    .describe(
      'Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language) for more details.'
    ),
});
export const QueryMemberAboutsResponse = z.object({
  memberAbouts: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('ID of the "About" section content.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Revision number, which increments by 1 each time the "About" section content is updated. To prevent conflicting changes, the existing revision must be used when updating an "About" section content.'
          )
          .optional()
          .nullable(),
        memberId: z
          .string()
          .describe('Member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        content: z
          .any()
          .describe(
            '<widget src="https://apps.wix.com/_serverless/ricos-playground-services/goto/api-component" plugins="image.video.divider.giphy.emoji.link" exampleid="9b569a8d-0fc1-40f4-987f-8bd40ecc72d0">Fallback Message for SSR and Error</widget>.'
          )
          .optional(),
      })
    )
    .optional(),
  metadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in current page.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
